// src/components/common/PostLoginPopUp.jsx
import React from "react";

const PostLoginPopup = ({ onPass, onFail }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center popup-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="role-title"
  >
    <div className="popup-card">
      <h2 id="role-title" className="title">
        Welcome! Pick your role
      </h2>

      <p className="subtitle">
        Let us guide you to the right experience.
      </p>

      <div className="btn-group">
        
        <button onClick={onPass} className="role-btn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M9 2.25h6A1.5 1.5 0 0 1 16.5 3.75V5.25h1.5A1.5 1.5 0 0 1 19.5 6.75v12.5A1.5 1.5 0 0 1 18 20.75H6A1.5 1.5 0 0 1 4.5 19.25V6.75A1.5 1.5 0 0 1 6 5.25h1.5V3.75A1.5 1.5 0 0 1 9 2.25z" />
            <path d="M9 11.25l2 2 4-4" />
          </svg>
          <span>I'm a Facilitator</span>
        </button>

      
        <button onClick={onFail} className="role-btn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M2 10.5L12 5l10 5.5-10 5.5L2 10.5z" />
            <path d="M12 10.5v9.25m0 0l6.5-3.575a12 12 0 00.5-5.675M12 19.75L5.5 16.175a12 12 0 01-.5-5.675" />
          </svg>
          <span>I'm a Participant</span>
        </button>
      </div>
    </div>

    <style>{`
      /* Overlay */
      .popup-overlay {
        background: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(4px);
        animation: fadeIn 0.25s ease;
      }

      /* Card - SMALL */
      .popup-card {
        background: #ffffff;
        width: 90%;
        max-width: 400px;
        padding: 2rem 1.5rem;
        border-radius: 1.5rem;
        box-shadow: 0 15px 40px rgba(0,0,0,0.2);
        text-align: center;
        animation: slideUp 0.3s ease;
      }

      /* Title */
      .title {
        font-size: 1.6rem;
        font-weight: 700;
        color: #36369f;
      }

      /* Subtitle */
      .subtitle {
        font-size: 0.9rem;
        color: #6b7280;
        margin-top: 0.4rem;
        margin-bottom: 1.5rem;
      }

      /* Button group */
      .btn-group {
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
      }

      @media (min-width: 640px) {
        .btn-group {
          flex-direction: row;
        }
      }

      /* Buttons */
      .role-btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        padding: 0.7rem;
        border-radius: 0.8rem;
        font-size: 0.9rem;
        font-weight: 600;
        color: #ffffff;
        background: #36369f;
        transition: all 0.2s ease;
      }

      .role-btn svg {
        width: 18px;
        height: 18px;
      }

      .role-btn:hover {
        background: #2b2b7a;
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(54,54,159,0.3);
      }

      .role-btn:active {
        transform: scale(0.96);
      }

      /* Animations */
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes slideUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `}</style>
  </div>
);

export default PostLoginPopup;